import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';

const AccountManagement =() => {
    return(
      <>
     <Breadcrumb />
      <Typography>
         AccountManagement works
       </Typography>
       </>
       );
};
export default AccountManagement;